import { ArrowRight } from '@carbon/icons-react';
import { Link as CarbonLink } from '@carbon/react';
import type { ComponentProps, ElementType } from 'react';
import type { IconComponent } from '../../types';

type CarbonLinkProps = ComponentProps<typeof CarbonLink>;

export interface CdLinkProps extends Omit<CarbonLinkProps, 'renderIcon'> {
  /** Shows the trailing arrow used for "Explore permit →" / "Help center →". */
  withArrow?: boolean;
  icon?: IconComponent;
  /** Render as another element, e.g. React Router's `Link` (pass `to` via rest props). */
  as?: ElementType;
}

export const CdLink = ({ withArrow = false, icon, ...rest }: CdLinkProps) => {
  return <CarbonLink renderIcon={icon ?? (withArrow ? ArrowRight : undefined)} {...rest} />;
};
